import { Route, Routes } from "react-router-dom";
import FileDetail from "./FileDetail";
import FilesList from "./FilesList";

/** Top-level router for /files/*. */
const FilesRouter: React.FC = () => (
  <Routes>
    <Route index element={<FilesList />} />
    <Route path=":source/:id" element={<FileDetail />} />
  </Routes>
);

export default FilesRouter;
